import { StyledSpecialist } from '@/components/styles';
import { Picture } from '@/components';
import genLinkParams from '@/lib/generateLinkParams';
import Icon from '@/assets/icons';
import Link from 'next/link';

export default function Specialist(props) {
  const {
    id,
    preview: imageFromProps,
    position,
    qualification,
    slug,
    first_name: firstName,
    last_name: lastName,
    patronymic,
    ...otherProps
  } = props;

  const [href, as] = genLinkParams({ type: 'specialist', slug });
  const image = imageFromProps || {};
  const title = `${lastName} ${firstName}${patronymic ? ' ' + patronymic : ''}`;

  return (
    <StyledSpecialist {...otherProps}>
      <Link href={href} as={as} passHref>
        <StyledSpecialist.Link />
      </Link>

      <StyledSpecialist.Bg>{/* <StyledSpecialist.Circle /> */}</StyledSpecialist.Bg>

      <StyledSpecialist.Img>{Object.keys(image).length > 0 && <Picture {...image} />}</StyledSpecialist.Img>

      <StyledSpecialist.Arrow>
        <Icon name="arrow-right" />
      </StyledSpecialist.Arrow>

      <StyledSpecialist.Content>
        <StyledSpecialist.Title>{title}</StyledSpecialist.Title>

        {position && <StyledSpecialist.Qualification>{position}</StyledSpecialist.Qualification>}
      </StyledSpecialist.Content>
    </StyledSpecialist>
  );
}
